// Punkt na żywo wykresu z widoku sztuki: gotowy punkt siatki workera (`widok.wykres` - co krok typu, wartości jak
// w próbkach bazy) - jedno źródło dla pulpitów, mini-wykresów i Statystyk, bez mapowania pól widoku na kanały.
import type { ViewDoc } from "../../gen/kontrakt";

/** Chwila punktu na żywo (unix s); undefined = sztuka nie online albo siatka jeszcze bez punktu. */
export const chwilaZywo = (w: ViewDoc): number | undefined => w.wykres?.t;

/** Wartości kanałów `idxs` (w tej kolejności) z punktu na żywo; null = kanał bez wartości (luka, brak czujnika). */
export function naZywoZ(idxs: readonly number[]): (w: ViewDoc) => (number | null)[] {
  return (w) => idxs.map((i) => w.wykres?.v.find((x) => x.idx === i)?.v ?? null);
}
